import { Box } from "@mui/material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import useDisplayDate from "../../hooks/Date/useDisplayDate";


const useLeadColumns = (onCellClick) => {
  const { formatDate } = useDisplayDate();

  return [
    { accessorKey: 'leadID', header: 'Lead ID',
      Cell: ({ cell, row }) => (
            <Box
              onClick={() => onCellClick?.(row.original)}
              sx={{cursor: 'pointer',color: 'primary.main',fontWeight: 600}}
            >
              {cell.getValue()}
            </Box>
      ), 
    },
      { accessorKey: 'customerID', header: 'Customer ID',size: 200,
        Cell: ({ cell, row }) => (
          <Box
            onClick={() => onCellClick?.(row.original)}
            sx={{cursor: 'pointer',color: 'primary.main',fontWeight: 600}}
          >
            {cell.getValue()}
          </Box>
        ), 
      },
      { accessorKey: 'purpose', header: 'Purpose' },
      { accessorKey: 'loanRequeried', header: 'Loan Required',size: 200,

          accessorFn: (row) => {
            const value = row.loanRequeried;
            const isNumeric = !isNaN(value) && value !== null && value !== '';
            return(
              <Box display="flex" alignItems="center">
                        {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                        {value}
              </Box>
            )
            
          }
       },
      { accessorKey: 'tenure', header: 'Tenure' },
      { accessorKey: 'monthlyIncome', header: 'Monthly Income',size: 300,

        accessorFn: (row) => {
          const value = row.monthlyIncome;
          const isNumeric = !isNaN(value) && value !== null && value !== '';
          return(
            <Box display="flex" alignItems="center">
                      {isNumeric && <CurrencyRupeeIcon color="secondary" />}
                      {value}
            </Box>
          )
          
        }
       },
      { accessorKey: 'salaryMode', header: 'Salary Mode',size: 200 },
      { accessorKey: 'city', header: 'City' },
      { accessorKey: 'state', header: 'State' },
      { accessorKey: 'pincode', header: 'Pincode' },
      { accessorKey: 'status', header: 'Status' },
      { accessorKey: 'utmSource', header: 'Source' },
      { accessorKey: 'fbLeads', header: 'FB Leads' },
      { accessorKey: 'commingLeadsDate', header: 'Comming Leads Date',size: 250,accessorFn: row => formatDate(row.createdDate), },
      { accessorKey: 'createdDate', header: 'Created Date',size: 200,accessorFn: row => formatDate(row.createdDate), },
  ];
};

export default useLeadColumns;
